import {NgModule} from "@angular/core";
import {RtlService} from "./services/rtl.service";

@NgModule({
})
export class RtlModule {
	public static forRoot(){
		return {
			ngModule: RtlModule,
			providers: [
				RtlService
			]
		};
	}
}
